import account from './account';
import brand from './brand';
import cart from './cart';
import checkout from './checkout';
import confirmation from './confirmation';
import globalEvents from './global';
import homepage from './homepage';
import landing from './landing';
import orders from './orders';
import product from './product';
import search from './search';
import rewards from './rewards';
import favorites from './favorites';

// Mapping needs to match up with getType() output
export default {
  account,
  brand,
  cart,
  checkout,
  confirmation,
  globalEvents,
  homepage,
  landing,
  orders,
  product,
  rewards,
  search,
  favorites
};
